<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <h1>Dashboard</h1>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Dashboard'
  }
</script>
